export const TERMS_OF_USE_HEADER = 'Terms of use'
export const PRIVACY_POLICY_HEADER = 'Privacy policy'
export const EXPRESSWAY_HEADER = 'Expressway'
export const WALLET_HEADER = 'Wallet'
export const SUPPORT_HEADER = 'Support'
export const SETTINGS_HEADER = 'Settings'
export const SETTINGS_LISTITEM_DESCRIPTION =
  'Enable expressway and start rolling'
export const EXPRESSWAY_LISTITEM_DESCRIPTION = 'Your saved cards'
export const WALLET_LISTITEM_DESCRIPTION = 'Your wallet balance'
export const SUPPORT_LISTITEM_DESCRIPTION = 'Contact Support team at Cleartrip'
export const TRIPLIST_HEADER = 'Bookings'
export const TRIPLIST_ALL_HEADER = 'All Bookings'
export const LEGAL_HEADER = 'Legal'
export const ACCOUNT_HEADER = 'Account'
export const ACCOUNTS_PAGE_HEADER = 'Profile'
export const TRIPS_PAGE_HEADER = 'Trips'

// Login Logout text
export const LOGOUT_HEADER = 'Sign out'
export const LOGIN_HEADER = 'Get the full cleartrip experience'
export const LOGIN_SUBHEADING =
  'Faster bookings, manage trips, easy refunds, support and much more'
export const LOGIN_BUTTON_TEXT = 'Sign in or Register'
export const PAGE_NOT_FOUND_TEXT = 'Whatever you\'re looking for, doesn\'t exist here.'
export const PAGE_NOT_FOUND_BUTTON = 'Back to home'
